import { NAV_GROUPS } from "./navConfig";

// Título + linha de apoio de cada tela (cabeçalho da página no AppShell) — mesmos textos do canvas
// de design aprovado. O grupo do breadcrumb vem do navConfig, pra não duplicar a estrutura do menu.
const SCREENS: Array<{ prefix: string; title: string; subtitle: string }> = [
  { prefix: "/app/aplicacoes", title: "Aplicações", subtitle: "Cada sistema vendido, com seus planos e a cláusula de objeto usada no contrato em PDF." },
  { prefix: "/app/clientes", title: "Clientes", subtitle: "Pessoas físicas e jurídicas com contrato, plano e acesso ao portal." },
  { prefix: "/app/contratos", title: "Contratos", subtitle: "O PDF é gerado ao criar o contrato. O dia de cobrança define o vencimento dos títulos." },
  { prefix: "/app/tipos-de-baixa", title: "Tipos de baixa", subtitle: "Formas de recebimento e pagamento escolhidas ao dar baixa em um título." },
  { prefix: "/app/niveis-habilidade", title: "Níveis de habilidade", subtitle: "Valor-hora usado nos itens de orçamento. Mudar o valor não altera orçamentos já criados." },
  { prefix: "/app/orcamentos", title: "Orçamentos", subtitle: "Horas por item × valor-hora do nível de habilidade. Para cliente cadastrado ou lead." },
  { prefix: "/app/receber", title: "Contas a receber", subtitle: "Gerados no dia 1 de cada mês, vencendo no dia de cobrança do contrato." },
  { prefix: "/app/pagar", title: "Contas a pagar", subtitle: "Fornecedores, impostos e despesas fixas da empresa." },
  { prefix: "/app/relatorios", title: "Relatórios", subtitle: "Resultado, fluxo de caixa, receita recorrente e inadimplência." },
  { prefix: "/app/configuracoes", title: "Configurações", subtitle: "Regras do portal do cliente." },
  { prefix: "/app/usuarios", title: "Usuários", subtitle: "Equipe com acesso ao sistema. O papel define quais menus cada pessoa vê." },
  { prefix: "/app/auditoria", title: "Auditoria", subtitle: "Registro de baixas, exclusões, mudanças de situação e acessos. Somente leitura." },
  { prefix: "/app", title: "Painel", subtitle: "" },
];

export type ScreenInfo = { title: string; subtitle: string; group: string };

export function screenInfoFor(pathname: string): ScreenInfo {
  const found = SCREENS.find((s) => pathname.startsWith(s.prefix));
  const group = NAV_GROUPS.find((g) => g.items.some((i) => i.path === found?.prefix))?.title ?? "";
  return { title: found?.title ?? "", subtitle: found?.subtitle ?? "", group };
}

export function screenTitleFor(pathname: string): string {
  return screenInfoFor(pathname).title;
}
